"use client";
import React from "react";

type PressTabKey = "PRESS_RELEASE" | "MANAGEMENT_INTERVIEW";

export default function PressTabs({
  active,
  onChange,
}: {
  active: PressTabKey;
  // eslint-disable-next-line no-unused-vars
  onChange: (_key: PressTabKey) => void;
}) {
  return (
    <div className="lg:max-w-[554px] w-[calc(100%_-_30px)] lg:h-[68px] lg:rounded-[88px] rounded-[10px] p-1.5 bg-[#ecf0f6] mx-auto">
      <div className="flex lg:flex-row flex-col h-full">
        <button
          type="button"
          onClick={() => onChange("PRESS_RELEASE")}
          className={`flex-1 h-full lg:rounded-[68px] rounded-[10px] px-10 py-2 text-[18px] font-semibold cursor-pointer ${
            active === "PRESS_RELEASE"
              ? "bg-white text-[#00040b]"
              : "text-[#00040b]"
          }`}
        >
          Press Releases
        </button>

        <button
          type="button"
          onClick={() => onChange("MANAGEMENT_INTERVIEW")}
          className={`flex-1 h-full lg:rounded-[68px] rounded-[10px] px-10 py-2 text-[18px] font-semibold cursor-pointer ${
            active === "MANAGEMENT_INTERVIEW"
              ? "bg-white text-[#00040b]"
              : "text-[#00040b]"
          }`}
        >
          Management Interview
        </button>
      </div>
    </div>
  );
}
